import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  usuarioId: 0,
  nombre: "",
  apellido: "",
  genero: "",
  fechaNacimiento: "",
  email: "",
  telefono: "",
  // tipoDoc: "",
  provinciaId: 0,
  departamentoId: 0,
  localidadId: 0,
  segmento: "1",
  sucursalId: 0,
  //plan: "",
  calleId: 0,
  calleAltura: "",
  callePiso: "",
  calleDepartamento: "",
  ubicacion: "",
  contratos: [],
};

const formSlice = createSlice({
  name: "form",
  initialState: INITIAL_STATE,
  reducers: {
    setUsuarioId: (state, action) => {
      state.usuarioId = action.payload;
    },
    setNombre: (state, action) => {
      state.nombre = action.payload;
    },
    setApellido: (state, action) => {
      state.apellido = action.payload;
    },
    setGenero: (state, action) => {
      state.genero = action.payload;
    },
    setFechNac: (state, action) => {
      state.fechaNacimiento = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setTel: (state, action) => {
      state.telefono = action.payload;
    },
    // setTipoDoc: (state, action) => {
    //   state.tipoDoc = action.payload;
    // },
    setDocumento: (state, action) => {
      state.documento = action.payload;
    },
    setPropiedad: (state, action) => {
      state.propiedad = action.payload;
    },
    setCalle: (state, action) => {
      state.calleId = action.payload;
    },
    setLocalidad: (state, action) => {
      state.localidadId = action.payload;
    },
    setDepartamento: (state, action) => {
      state.departamentoId = action.payload;
    },
    setProvincia: (state, action) => {
      state.provinciaId = action.payload;
    },
    setSegmento: (state, action) => {
      state.segmento = action.payload;
    },
    setSucursal: (state, action) => {
      state.sucursalId = action.payload;
    },
    // setPlan: (state, action) => {
    //   state.plan = action.payload;
    // },
    setPuerta: (state, action) => {
      state.calleAltura = action.payload;
    },
    setPiso: (state, action) => {
      state.callePiso = action.payload;
    },
    setDpto: (state, action) => {
      state.calleDepartamento = action.payload;
    },
    setUbicacion: (state, action) => {
      state.ubicacion = action.payload;
    },
    addPlanComercial: (state, action) => {
      //Agrego una card al array
      state.contratos.push(action.payload);
    },
    updatePlanComercial: (state, action) => {
      // Upsert: si existe ese id lo reemplaza, si no lo agrega.
      // Garantiza que cada tarjeta visible tenga exactamente un contrato.
      const index = state.contratos.findIndex(
        (plan) => plan.id === action.payload.id
      );
      if (index !== -1) {
        state.contratos[index] = action.payload;
      } else {
        state.contratos.push(action.payload);
      }
    },
    clearPlanComercial: (state) => {
      state.contratos = []; // Resetea el array a vacío
    },
    resetFormulario: () => ({
      ...INITIAL_STATE,
      contratos: [],
    }),
  },
});

export const {
  setUsuarioId,
  setNombre,
  setApellido,
  setGenero,
  setFechNac,
  setEmail,
  setTel,
  //setTipoDoc,
  setDocumento,
  setPropiedad,
  setCalle,
  setLocalidad,
  setDepartamento,
  setProvincia,
  setFormulario,
  setSegmento,
  setSucursal,
  // setPlan,
  setPuerta,
  setPiso,
  setDpto,
  setUbicacion,
  addPlanComercial,
  updatePlanComercial,
  clearPlanComercial,
  resetFormulario,
} = formSlice.actions;
export default formSlice.reducer;
